'use strict';

/**
 * @generated SignedSource<<1695b82350c437cd0a537be68b4ddc2f>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "offerIds"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "offerIds",
                    "variableName": "offerIds"
                }
            ],
            "concreteType": "OnlineStockResponse",
            "kind": "LinkedField",
            "name": "onlineStock",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "stockStatus",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "ShippingOptionQuery",
            "selections": (v1 /*: any*/),
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "ShippingOptionQuery",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "3aaf72a106f2e39f85f8e67d2866c573",
            "id": null,
            "metadata": {},
            "name": "ShippingOptionQuery",
            "operationKind": "query",
            "text": "query ShippingOptionQuery(\n  $offerIds: [String!]!\n) {\n  onlineStock(offerIds: $offerIds) {\n    stockStatus\n  }\n}\n"
        }
    };
})();
node.hash = "3460cf057f8dcd83f443f0e625dea033";

module.exports = node;
